import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedReturns: [],
};

const inboundOrdersSlice = createSlice({
	name: 'inboundOrders',
	initialState: initialState,
	reducers: {
		setInboundOrders: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setInboundOrders, reset } = inboundOrdersSlice.actions;

export default inboundOrdersSlice.reducer;